import { Form, FormProps } from 'antd';
import { Flex } from 'theme-ui';
import { BasePage, BasePageProps } from './PageBase';

export const Page: React.FC<BasePageProps> = ({ children, ...props }) => (
  <BasePage {...props}>
    <Content>
      {children}
    </Content>
  </BasePage>
);

export const PageForm: React.FC<FormProps> = ({ title, form, children, ...props }) => (
  <BasePage title={title}>
    <Form form={form}
      {...props}
      layout="vertical"
      autoComplete="off"
    >
      <Content>
        {children}
      </Content>
    </Form>
  </BasePage>
);

const Content: React.FC = ({ children }) => (
  <Flex sx={{ flexDirection: ['column', 'column', 'row'], gap: 24 }}>
    {children}
  </Flex>
);
